<ion-header>
  <ion-toolbar>
    <ion-title mode="md">Record Care Event</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel(true)">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [formGroup]="form">
  <div class="step-container">
    <!-- Select action -->
    <ion-label class="step-label">Select action</ion-label>
    <div class="button-group">
      <ion-radio-group formControlName="action">
        <ion-button *ngFor="let action of actions"
          [fill]="form.get('action')?.value === action.value ? 'solid' : 'outline'"
          color="primary">
          <ion-radio [value]="action.value">{{ action.label }}</ion-radio>
        </ion-button>
      </ion-radio-group>
    </div>

    <!-- Select reason -->
    <ng-container *ngIf="form.get('action')?.value">
      <ion-label class="step-label">Select reason</ion-label>
      <div class="button-group">
        <ion-radio-group formControlName="reason">
          <ion-button *ngFor="let reason of getReasons()"
            [fill]="form.get('reason')?.value === reason.value ? 'solid' : 'outline'"
            color="primary">
            <ion-radio [value]="reason.value">{{ reason.label }}</ion-radio>
          </ion-button>
        </ion-radio-group>
      </div>
    </ng-container>

    <!-- Select event type -->
    <ng-container *ngIf="isEventTypeRequired()">
      <ion-label class="step-label">Select event type</ion-label>
      <div class="button-group">
        <ion-radio-group formControlName="eventType">
          <ion-button *ngFor="let eventType of eventTypes"
            [fill]="form.get('eventType')?.value === eventType.value ? 'solid' : 'outline'"
            color="primary">
            <ion-radio [value]="eventType.value">{{ eventType.label }}</ion-radio>
          </ion-button>
        </ion-radio-group>
      </div>
    </ng-container>

    <!-- Optional notes -->
    <ion-label class="step-label">Add notes (optional)</ion-label>
    <ion-textarea class="record-care-event-notes" formControlName="notes" placeholder="Enter notes here..."
      [counter]="true" maxlength="255" [counterFormatter]="customCounterFormatter" slot="start">
    </ion-textarea>
  </div>
</ion-content>

<ion-footer class="modal-footer ion-no-border">
  <div class="action-button">
    <ion-button color="danger" (click)="cancel()" fill="outline">
      Cancel
    </ion-button>
    <ion-button [disabled]="form.invalid" color="primary" (click)="submit()">
      Submit
    </ion-button>
  </div>
</ion-footer>
